'use strict';
//This directive allows you to duplicate table column widths for a nested table.
//To use add table-cell-width="id-of-source-table" to the table row whose widths you would like to force.

angular.module('clientDashboardApp').directive('tableCellWidth', function ($timeout,$window) {
  return {
    restrict: "A",
    link: function(scope,element, attr){

      var w = angular.element($window);
      var headerRow = $('#'+attr["tableCellWidth"]+" > thead > tr > th");
      var widths = [];

      updateWidths();

      w.bind('resizeEnd', function() {
        updateWidths();
      });

      function updateWidths(){
        $timeout(function(){

          headerRow.each(function(ind,el){
            widths.push(el.getBoundingClientRect().width);
          });

          $(element).children().each(function(ind,el){
            $(el).innerWidth(widths[ind]);
          });

        });
      }
    }

  }
});
